/* eslint-disable @typescript-eslint/no-explicit-any */

export const objectKeys = <T extends { [_: string]: any }, K extends keyof T>(obj: T): K[] =>
  Object.keys(obj) as K[];

export const objectValues = <T extends { [_: string]: any }, K extends keyof T>(obj: T): T[K][] =>
  Object.values(obj);

export const getEnumValueByStringValue = <T>(
  enumObj: T,
  value: string | undefined
): T[keyof T] | undefined => {
  if (typeof value === 'undefined') {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyEnumObj = enumObj as any;
  const result = Object.entries(anyEnumObj).find(([_, enumValue]) => String(enumValue) === value);
  const [key] = result || [];

  return key ? anyEnumObj[key] : undefined;
};

export default getEnumValueByStringValue;
